var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", { class: [{ selected: _vm.selectedEnhancementData }] }, [
    _c(
      "div",
      {
        staticClass: "enhancements-card",
        class: {
          selected: _vm.selectedEnhancementData,
          "have-error": _vm.haveError,
          disabled: _vm.isDisabled,
        },
        attrs: { "data-component": "enhancements-card" },
      },
      [
        _c("div", { staticClass: "enhancements-card-container selected" }, [
          !_vm.haveIcon
            ? _c("div", { staticClass: "enhancements-card-image" }, [
                _c(
                  "picture",
                  {
                    directives: [
                      {
                        name: "lazyload",
                        rawName: "v-lazyload",
                        value: {
                          src: _vm.enhancement.icon,
                          set: [
                            { width: "160", height: "160", breakpoint: "xs" },
                            { width: "800", height: "360", breakpoint: "lg" },
                          ],
                          fit: "crop",
                          align: "center",
                        },
                        expression:
                          "{\n            src: enhancement.icon,\n            set: [\n              { width: '160', height: '160', breakpoint: 'xs' },\n              { width: '800', height: '360', breakpoint: 'lg' },\n            ],\n            fit: 'crop',\n            align: 'center',\n          }",
                      },
                    ],
                    staticClass: "image-wrapper",
                  },
                  [
                    _c("img", {
                      staticClass: "image",
                      attrs: {
                        src: "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==",
                        alt: _vm.enhancement.name,
                      },
                    }),
                  ]
                ),
              ])
            : _c("div", [
                _c("img", {
                  attrs: {
                    src: _vm.enhancement.icon,
                    alt: _vm.enhancement.name,
                  },
                }),
              ]),
          _vm._v(" "),
          _c("div", { staticClass: "enhancements-card-wrapper" }, [
            _c("div", { staticClass: "enhancements-card-body" }, [
              _c("div", { staticClass: "enhancements-card-title" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.enhancement.name) +
                    "\n          "
                ),
              ]),
              _vm._v(" "),
              _vm.enhancementShortDescription && !_vm.enhancementSummaryShort
                ? _c(
                    "div",
                    { staticClass: "enhancements-card-short-description" },
                    [_vm._v(_vm._s(_vm.enhancementShortDescription))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.enhancementSummaryShort &&
              _vm.enhancement.userInput !== "No input"
                ? _c("div", {
                    staticClass: "enhancements-card-short-summary",
                    domProps: {
                      innerHTML: _vm._s(_vm.enhancementSummaryShort),
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.enhancement.userInput !== "No input" &&
              _vm.selectedEnhancementData
                ? _c("div", { staticClass: "enhancements-card-details" }, [
                    _c("div", { staticClass: "enhancements-card-ctas" }, [
                      _c(
                        "button",
                        {
                          staticClass: "edit",
                          attrs: { disabled: _vm.cartPending },
                          on: {
                            click: function ($event) {
                              return _vm.$emit(
                                "edit-enhancement",
                                Object.assign(
                                  {},
                                  _vm.enhancement,
                                  _vm.selectedEnhancementData
                                )
                              )
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.haveError
                                  ? _vm.tc("enhancements.actionRequired")
                                  : _vm.tc("booking.editDetails")
                              ) +
                              "\n              "
                          ),
                        ]
                      ),
                    ]),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "enhancements-card-button",
                class: { selected: _vm.selectedEnhancementData },
                attrs: {
                  id: "enhancement-" + _vm.enhancement.sitecoreId,
                  disabled: _vm.isDisabled,
                  "aria-disabled": _vm.isDisabled,
                  "aria-pressed": _vm.selectedEnhancementData
                    ? "true"
                    : "false",
                  "aria-label": _vm.selectedEnhancementData
                    ? _vm.tc("booking.remove") + " " + _vm.enhancement.name
                    : _vm.tc("booking.add") + " " + _vm.enhancement.name,
                },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.handleClick($event)
                  },
                  keypress: [
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      $event.preventDefault()
                      return _vm.handleClick($event)
                    },
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "space", 32, $event.key, [
                          " ",
                          "Spacebar",
                        ])
                      ) {
                        return null
                      }
                      $event.preventDefault()
                      return _vm.handleClick($event)
                    },
                  ],
                },
              },
              [
                _vm.haveError
                  ? _c("div", [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "26px",
                            viewBox: "0 0 26 26",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M11.2088 4.19121L2.33547 19.0045C2.15252 19.3214 2.05572 19.6806 2.0547 20.0464C2.05367 20.4123 2.14846 20.772 2.32963 21.0899C2.5108 21.4077 2.77204 21.6726 3.08735 21.8581C3.40267 22.0436 3.76107 22.1434 4.1269 22.1474H21.8736C22.2394 22.1434 22.5978 22.0436 22.9131 21.8581C23.2284 21.6726 23.4897 21.4077 23.6708 21.0899C23.852 20.772 23.9468 20.4123 23.9458 20.0464C23.9447 19.6806 23.8479 19.3214 23.665 19.0045L14.7917 4.19121C14.6049 3.88332 14.3419 3.62876 14.0281 3.45209C13.7144 3.27543 13.3603 3.18262 13.0002 3.18262C12.6401 3.18262 12.2861 3.27543 11.9723 3.45209C11.6585 3.62876 11.3956 3.88332 11.2088 4.19121V4.19121Z",
                              stroke: "white",
                              "stroke-width": "1.5",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "M13 9.57617V13.7666",
                              stroke: "white",
                              "stroke-width": "1.5",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "M13 17.957H13.0105",
                              stroke: "white",
                              "stroke-width": "1.5",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                            },
                          }),
                        ]
                      ),
                    ])
                  : !_vm.selectedEnhancementData
                  ? _c("div", {
                      class:
                        "icon-" +
                        (_vm.isLoading && _vm.cartPending
                          ? "loading-black"
                          : "add"),
                    })
                  : _c("div", {
                      class:
                        "icon-" +
                        (_vm.isLoading && _vm.cartPending
                          ? "loading"
                          : "checkmark"),
                    }),
              ]
            ),
          ]),
        ]),
      ]
    ),
    _vm._v(" "),
    _vm.haveError
      ? _c("div", { staticClass: "enhancements-card-error" }, [
          _vm._v("\n    " + _vm._s(_vm.compPrivilegeErrorMessage) + "\n  "),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }